import { FC } from 'react';
import Layout from '@/components/layout/Layout';
import BookCardItem from '@/components/ui/book-card-item/BookCardItem';
import Pagination from '@/components/ui/pagination/Pagination';
import Breadcrumbs from '@/components/ui/breadcrumbs/Breadcrumbs';
import SectionTitle from '@/components/ui/section-title/SectionTitle';
import { useGetUrlPath } from '@/hooks/useGetUrlPath';
import { IBookPage, IBooksPageData } from '@/interfaces/booksPage.interface';
import { IWidgetsSideBar } from '@/interfaces/widgets.interface';
import { getCurrentYear, getCurrentMonth } from '@/helpers/helpers';
import { BOOKS_FOR_PAGE } from '@/helpers/variables';

export interface IFreeBooks extends IWidgetsSideBar {
  books: IBookPage;
}

const FreeBooks: FC<IFreeBooks> = ({ books, todayWidget, popularBooksWidget }) => {
  const pagesCount = Math.ceil(books?.total_count / BOOKS_FOR_PAGE);
  const currentYear = getCurrentYear();
  const currentMonth = getCurrentMonth();

  //Seo block
  const SEO_TITLE = `Читать бесплатные книги онлайн без регистрации`;
  const SEO_DESCRIPTION = `Полностью бесплатные версии книг. Читайте книги онлайн или скачайте в формате FB2, TXT, PDF, EPUB, DOC бесплатно и без регистрации в библиотеке BookZ`;
  const SEO_CANONICAL = '/free_books';

  return (
    <Layout title={SEO_TITLE} description={SEO_DESCRIPTION} canonicalHref={SEO_CANONICAL} pageHref={useGetUrlPath()} breadcrumbs={<Breadcrumbs firstPageName="Бесплатные книги" />} todayWidget={todayWidget} popularBooksWidget={popularBooksWidget}>
      <SectionTitle name="Бесплатные книги" />
      <div>{books.data && books.data.length > 0 ? books.data.map((book: IBooksPageData) => <BookCardItem book={book} key={book.id} />) : <div>Книги не найдены</div>}</div>
      <Pagination pagesCount={pagesCount ?? 0} postName="free_books/page=" />
    </Layout>
  );
};

export default FreeBooks;
